import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type DeleteProductCategoryMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.DeleteCoreProductCategoryInput;
}>;

export type DeleteProductCategoryMutationResult = { __typename?: 'Mutation' } & {
  deleteCoreProductCategory: { __typename?: 'DeleteCoreProductCategoryPayload' } & {
    errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
  };
};

export const DeleteProductCategoryDocument = gql`
  mutation deleteProductCategory($input: DeleteCoreProductCategoryInput!) {
    deleteCoreProductCategory(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
